
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rates",
      function () {
        return require("private-next-pages/rates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rates"])
      });
    }
  